export default __webpack_public_path__ + "static/media/ally_plus_main.e78bd5f6.png";